import React from "react";
import { Typography } from "@material-ui/core";
import { Action, SimpleDialog } from "../../components/CustomDialog";
import { ErrorLevel } from "./ErrorProvider";
import { useGlobalError } from ".";

export const ErrorModal: React.FC = () => {
  const { error, clearError } = useGlobalError();

  return error ? (
    <SimpleDialog
      aria-labelledby="Error alert"
      data-testid="ErrorModal"
      maxWidth="xs"
      variant={error.level === ErrorLevel.Info ? "info" : "error"}
      title={error.title}
      actions={[
        <Action
          label={error.handlerText}
          onClick={clearError}
          data-testid="ErrorModal__Button"
        />,
      ]}
    >
      <Typography variant="body1" color="textPrimary">
        {error.message}
      </Typography>
    </SimpleDialog>
  ) : null;
};
